// 根据环境动态设置 Vue 引用
import Vue from '@/loadVue'
const {createApp} = Vue;
import App from '@/App.vue';
import axios, {injectOtherResponseComponent, injectOtherRequestComponent} from '@/axios'
import i18n from '@/i18n'
import router from '@/router/index';
import store from '@/store/index';
import '@/global.css';
import '@/globalHeader.css';
import '@/globalFooter.css';
import ElementPlusIconsVue from "@/elementPlusicons";
import ElementPlus from '@/loadElementPlus'
import Cookies from '@/loadCookies';
import { initCountly, addCustmEvent } from '@/loadCountly';



const app = createApp(App)
app.use(store)
app.use(router)
app.use(ElementPlus, {zIndex: 99999999})
app.use(i18n)
// app.use(infiniteScroll)
injectOtherRequestComponent(store, Cookies, i18n);
injectOtherResponseComponent(store);

app.config.globalProperties.$axios = axios
app.config.globalProperties.$cookies = Cookies
app.config.globalProperties.$debounce = debounce


// 初始化Countly
const Countly = await initCountly();
// console.log("创建vue")
// 全局错误捕获
window.onerror = function(message, source, lineno, colno, error) {
    let properties = {
        'error_message': message,  // 错误消息
        'error_source': source,    // 错误来源
        'error_line': lineno,      // 错误所在行
        'error_column': colno,     // 错误所在列
        'error_stack': error? error.stack : "No stack trace"  // 堆栈跟踪信息
    }
    addCustmEvent('全局异常', 'js_error', window.location.pathname, properties);
    return false;  // 返回false可让浏览器继续默认的错误处理
};
// Promise 未处理拒绝捕获
window.addEventListener('unhandledrejection', function(event) {
    let properties = {
        'error_message': event.reason? event.reason.message : "Unknown reason",  // 错误消息
        'error_source': event.reason? event.reason.stack : "No stack trace"  // 堆栈跟踪信息
    }
    addCustmEvent('未处理拒绝捕获异常', 'js_error', window.location.pathname, properties)
});
// 资源加载错误捕获
window.addEventListener('error', function(event) {
    if (event.target instanceof HTMLScriptElement || 
        event.target instanceof HTMLLinkElement || 
        event.target instanceof HTMLImageElement) {
        let properties = {
            'error_message': event.message,  // 错误消息
            'error_source': event.filename,  // 错误来源文件
            'resource': event.target.src || event.target.href,  // 加载失败的资源URL
            'type': event.target.tagName                         // 资源类型（SCRIPT、LINK、IMG）
        }
        addCustmEvent('资源加载失败', 'js_error', window.location.pathname, properties)

    }
}, true);  // 使用捕获阶段（Capture phase）很关键

app.config.globalProperties.$Countly = Countly;
// 全局注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
}

app.mount('#app')

export function debounce(func, wait) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}
